import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  Box,
  Grid,
  CircularProgress,
  Rating,
  TextField,
  useTheme,
} from "@mui/material";
import { homeService } from "services";

const AppRating = (props) => {
  const theme = useTheme();
  const { deviceInfo } = props;
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const [openAppRating, setOpenAppRating] = useState(false);
  const [isAppRatingCancel, setIsAppRatingCancel] = useState(false);
  const [showAppRatingSuccess, setAppRatingSuccess] = useState(null);
  const [loading, isLoading] = useState(false);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");

  useEffect(() => {
    if (
      !window?.location?.pathname?.includes("/savings") &&
      !isAppRatingCancel &&
      deviceInfo !== null &&
      deviceInfo?.ratingFlag === "Y" &&
      deviceInfo?.shareAppFlag === "Y"
    ) {
      setOpenAppRating(true);
    }
  }, [deviceInfo]);

  const handleClose = () => {
    setOpenAppRating(false);
    setIsAppRatingCancel(true);

    if (!showAppRatingSuccess) {
      homeService.muteAppRating(deviceInfo?.ratingEngagementId);
    }
  };

  const onFormSubmit = () => {
    isLoading(true);
    homeService
      .appRating(rating, deviceInfo?.ratingEngagementId, feedback)
      .then((res) => {
        setAppRatingSuccess(res);
        isLoading(false);
        //call device endpoint to re-update the deviceInfo sessionStorage
        homeService.getDeviceDetails();
      })
      .catch((e) => {
        console.log(e);
        isLoading(false);
        setOpenAppRating(false);
        setIsAppRatingCancel(true);
      });
  };

  return (
    <>
      <Dialog
        //fullWidth={true}
        // maxWidth={"sm"}
        onClose={handleClose}
        open={openAppRating}
        className="app-dialog"
      >
        <DialogTitle sx={{ color: "#002060", textAlign: "center" }}>
          Rate your experience!
        </DialogTitle>
        <DialogContent
          sx={{
            paddingLeft: matchesMinWidth ? "24px" : "40px",
            paddingRight: matchesMinWidth ? "24px" : "40px",
          }}
        >
          {loading && (
            <Box sx={{ textAlign: "center" }} mt={2}>
              <CircularProgress
                style={{ color: theme?.palette?.secondary?.main }}
              />
            </Box>
          )}
          {!showAppRatingSuccess && !loading && (
            <>
              <Box mt={1}>
                <Grid
                  item
                  sx={{ display: "flex", justifyContent: "center" }}
                  xs={12}
                >
                  <Rating
                    onChange={(event, newValue) => {
                      setRating(newValue);
                    }}
                    precision={0.25}
                    name="size-large"
                    defaultValue={rating}
                    size="large"
                  />
                </Grid>
                <Grid
                  mt={2}
                  item
                  sx={{ display: "flex", justifyContent: "center" }}
                  xs={12}
                >
                  <TextField
                    variant="standard"
                    label="Comments"
                    style={{ textAlign: "left" }}
                    multiline
                    rows={2}
                    value={feedback}
                    onChange={(e) => {
                      setFeedback(e.target.value);
                    }}
                  />
                </Grid>
              </Box>
              <Box sx={{ textAlign: "center" }} mt={3} mb={1}>
                <Button
                  disabled={!rating}
                  onClick={() => onFormSubmit()}
                  sx={{
                    width: 200,
                    backgroundColor: !rating ? "#e6e6e6" : "#83d712",
                  }}
                  variant="filled"
                >
                  RATE
                </Button>
              </Box>
            </>
          )}

          {showAppRatingSuccess && !loading && (
            <Grid sx={{ textAlign: "center" }} item xs={12}>
              <Typography variant="h4LatoRegular" sx={{ color: "#607277" }}>
                {showAppRatingSuccess.message}
              </Typography>
            </Grid>
          )}
          {!loading && (
            <Box sx={{ textAlign: "center" }} mt={2}>
              <Button
                sx={{ minWidth: 200 }}
                onClick={() => {
                  handleClose();
                }}
              >
                {showAppRatingSuccess ? "OK" : "CANCEL"}
              </Button>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data,
    authData: state.authentication.authData,
    deviceInfo: JSON.parse(sessionStorage.getItem("deviceInfo")),
    // organizationInfo: { suffix: "WGN" },
  };
};

export default connect(mapStateToProps)(AppRating);
